module.exports = __webpack_public_path__ + "assets/lixpen-df54a1dd5ce20fe34fe6ea2b73967e7a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/data/images/lixpen.jpg
// module id = 516
// module chunks = 1